import React from 'react';
import styled from 'styled-components';

// Import each of the icons in use by the app.
import ChevronDownIcon from 'react-feather/dist/icons/chevron-down';
import ChevronLeftIcon from 'react-feather/dist/icons/chevron-left';
import ChevronRightIcon from 'react-feather/dist/icons/chevron-right';
import Copy from 'react-feather/dist/icons/copy';
import MenuIcon from 'react-feather/dist/icons/menu';
import MoreVerticalIcon from 'react-feather/dist/icons/more-vertical';
import CloseIcon from 'react-feather/dist/icons/x';
import AlertCircleIcon from 'react-feather/dist/icons/alert-circle';
import AlertTriangleIcon from 'react-feather/dist/icons/alert-triangle';
import InboxIcon from 'react-feather/dist/icons/inbox';
import PieChartIcon from 'react-feather/dist/icons/pie-chart';
import ClipboardIcon from 'react-feather/dist/icons/clipboard';
import DatabaseIcon from 'react-feather/dist/icons/database';
import BellIcon from 'react-feather/dist/icons/bell';
import UserIcon from 'react-feather/dist/icons/user';
import CheckIcon from 'react-feather/dist/icons/check';
import AlignJustifyIcon from 'react-feather/dist/icons/align-justify';
import Trash2Icon from 'react-feather/dist/icons/trash-2';
import PlusIcon from 'react-feather/dist/icons/plus';
import ListIcon from 'react-feather/dist/icons/list';
import CalendarIcon from 'react-feather/dist/icons/calendar';
import EditIcon from 'react-feather/dist/icons/edit';
import MonitorIcon from 'react-feather/dist/icons/monitor';
import TrendingUpIcon from 'react-feather/dist/icons/trending-up';
import BarChart2Icon from 'react-feather/dist/icons/bar-chart-2';
import HomeIcon from 'react-feather/dist/icons/home';
import SlashIcon from 'react-feather/dist/icons/slash';
import UploadCloudIcon from 'react-feather/dist/icons/upload-cloud';
import ArrowRightIcon from 'react-feather/dist/icons/arrow-right';
import { GoPin } from 'react-icons/go'
import EyeIcon from 'react-feather/dist/icons/eye';
import ExternalLink from 'react-feather/dist/icons/external-link';
import Minimize2 from 'react-feather/dist/icons/minimize-2';
import Info from 'react-feather/dist/icons/info';
import FileText from 'react-feather/dist/icons/file-text';
import { Grid } from 'react-feather';

export const ICON_MAP = {
  'chevron-down': ChevronDownIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-left': ChevronLeftIcon,
  'copy': Copy,
  'menu': MenuIcon,
  'more-vertical': MoreVerticalIcon,
  'close': CloseIcon,
  'alert-circle': AlertCircleIcon,
  'alert-triangle': AlertTriangleIcon,
  'inbox': InboxIcon,
  'pie-chart': PieChartIcon,
  'clipboard': ClipboardIcon,
  'database': DatabaseIcon,
  'bell': BellIcon,
  'user': UserIcon,
  'check': CheckIcon,
  'align-justify': AlignJustifyIcon,
  'trash-2': Trash2Icon,
  'plus': PlusIcon,
  'list': ListIcon,
  'calendar': CalendarIcon,
  'edit': EditIcon,
  'trending-up': TrendingUpIcon,
  'monitor': MonitorIcon,
  'bar-chart-2': BarChart2Icon,
  'home': HomeIcon,
  'slash': SlashIcon,
  'upload-cloud': UploadCloudIcon,
  'arrow-right': ArrowRightIcon,
  'go-pin' : GoPin,
  'eye': EyeIcon,
  'external-link': ExternalLink,
  'minimize': Minimize2,
  'info': Info,
  'grid': Grid,
  'file-text': FileText,
};

function Icon({name, size = '1em', ...props}) {
  const Component = ICON_MAP[name];

  if (!Component) {
    throw new Error(`No such icon: ${name}. Did you forget to import it?`);
  }

  if (('' + size).indexOf('rem') >= 0) {
    throw new Error('<Icon /> components do not support rem units of meaurement. Use em instead.');
  }

  return (
    <Container size={size}>
      <Component size={size} {...props} />
    </Container>
  );
}

const Container = styled.span`
  font-size: 1rem;
  height: ${props => props.size};
  width: ${props => props.size};
`;

export default styled(Icon)``;
